<template>
  <div v-if="options">
    <v-form>
      <v-container fluid>
        <v-row>
          <v-col xs="12" sm="6" md="4" lg="3">
            <v-autocomplete
              :clearable="true"
              v-model="selected.province"
              :items="provincesList"
              :label="$t('globals.province')"
              :rules="[$rules.required]"
              class="required"
              item-value="Id"
              :item-text="trans"
              return-object
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="3">
            <v-autocomplete
              :clearable="true"
              :label="$t('headers.t4a_archive.year')"
              v-model="selected.year"
              clear-icon="clear"
              :items="years"
              :rules="[$rules.required]"
              class="required"
              item-value="Year"
              item-text="Year"
              return-object
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-autocomplete
              :clearable="true"
              :label="$t('components.guides.import_guide_dialog.geolocation')"
              v-model="selected.geolocation"
              clear-icon="clear"
              :items="geolocations"
              :rules="[$rules.required]"
              class="required"
              item-value="GeoLocation"
              :item-text="(item)=>translateEnum(item)"
              return-object
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="3">
            <v-autocomplete
              :clearable="true"
              :label="
                $t('components.guides.health_reasonable_customary.guides')
              "
              v-model="selected.guide"
              clear-icon="clear"
              :items="guides"
              item-text="Name"
              return-object
              :rules="[$rules.required]"
              class="required"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <error-handler :error="error"></error-handler>
  </div>
  <v-row justify="center" v-else>
    <v-progress-circular
      :size="70"
      :width="7"
      color="purple"
      indeterminate
    ></v-progress-circular>
  </v-row>
</template>

<script>
import ErrorHandler from "../../components/ErrorHandler.vue";
import { mapActions, mapGetters } from "vuex";
import TransSelect from "../TransSelect.vue";
import { translate } from "@/trans";
export default {
  props: [ "coverage"],
  components: {
    ErrorHandler,
    TransSelect,
  },
  data() {
    return {
      error: null,
      successDialog: false,
      valid: false,
      saving: false,
      loading: false,
      selected: {
        guide: null,
        year: null,
        province: null,
        geolocation: null,
      },
      provinces: [],
      guides: [],
      years: [],
      provincesList: null,
      geolocations: [],
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", ["language"]),
  },
  watch: {
    "selected.province": {
      handler(v) {
        if (v) {
          console.log("p is ", v);
          let province = this.provinces.filter((o) => o.ProvinceId === v.Id)[0];
          this.years = province.Years;
          this.geolocations = [];
          this.guides = [];
          this.selected.year = null;
          this.selected.guide = null;
          this.selected.geolocation = null;
          if (this.years.length === 1) {
            this.selected.year = this.years[0];
          }
          this.$emit("update", this.createFilter());
        }
      },
    },
    "selected.year": {
      handler(v) {
        if (v) {
          this.geolocations = v.GeoLocations;
          this.guides = [];
          if (this.geolocations.length === 1) {
            this.selected.geolocation = this.geolocations[0];
          }
          this.$emit("update", this.createFilter());
        }
      },
    },
    "selected.guide": {
      handler(v) {
        if (v) {
          this.$emit("update", this.createFilter());
        }
      },
    },
    "selected.geolocation": {
      handler(v) {
        if (v) {
          this.guides = v.Names;
          if (this.guides.length === 1) {
            this.selected.guide = this.guides[0];
          }
          this.$emit("update", this.createFilter());
        }
      },
    },
    options: {
      handler(v) {
        if (v) {
          console.log("options: ", JSON.stringify(this.options));
          this.loadProvinces();
        }
      },
    },
  },
  mounted() {
    if (this.options) {
      console.log("mounted: ", JSON.stringify(this.options));
      this.loadProvinces();
    }
  },
  methods: {
    ...mapActions("claims", ["getFeeGuides"]),
    translateEnum(item) {
      return this.$t(`enums.${item.GeoLocation}`);
    },
    trans(item) {
      // console.log("!@!@!@!@!@!@!@!@!@!@!@!@!@!@!@!@!@!2", item, this.language.language);
      let a=translate(item, this.language.language);
      // console.log(a);
      return a;
    },
    async loadProvinces() {
      try {
        this.provinces = (
          await this.getFeeGuides({
            coverage: this.coverage,
          })
        ).data;
        console.log("load: ", JSON.stringify(this.options));
        this.provincesList = this.options.Models.Province.filter(
          (o) =>
            this.provinces.filter((oo) => oo.ProvinceId === o.Id).length > 0
        );
      } catch (error) {
        this.error = error;
      }
    },
    createFilter() {
      console.log("guide is: ",this.selected.guide)
      let filters = [];
      if (
        this.selected.guide === null ||
        this.selected.guide === undefined ||
        this.selected.year === null ||
        this.selected.year === undefined ||
        this.selected.province === null ||
        this.selected.province === undefined ||
        this.selected.geolocation === null ||
        this.selected.geolocation === undefined
      ) {
        return null;
      }
      filters.push(`FeeGuide/Name eq '${this.selected.guide}'`);
      filters.push(`FeeGuide/Year eq ${this.selected.year.Year}`);
      filters.push(`FeeGuide/ProvinceId eq ${this.selected.province.Id}`);
      filters.push(`FeeGuide/GeoLocation eq '${this.selected.geolocation.GeoLocation}'`);
      return filters.join(` and `);
    },
  },
};
</script>

<style></style>
